export class CheckoutLoadingModalController {
  // bindings
  message: string;
}
